import { render, staticRenderFns } from "./BankTransferPaymentDetails.vue?vue&type=template&id=43ca5031&scoped=true&"
import script from "./BankTransferPaymentDetails.vue?vue&type=script&lang=js&"
export * from "./BankTransferPaymentDetails.vue?vue&type=script&lang=js&"
import style0 from "./BankTransferPaymentDetails.vue?vue&type=style&index=0&id=43ca5031&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ca5031",
  null
  
)

export default component.exports